import { HostBinding } from "@angular/core";

export class IconComponent {

  @HostBinding('style.display') public display: string = 'inline-flex';

  constructor() {
  }
}
